import { render, staticRenderFns } from "./CartDisplayItem.vue?vue&type=template&id=3476f9fe&scoped=true&"
import script from "./CartDisplayItem.vue?vue&type=script&lang=js&"
export * from "./CartDisplayItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476f9fe",
  null
  
)

export default component.exports